import React from 'react';

import { SearchDocumentType, SearchPostBody } from '../../../../graphql/gen/types';
import { SearchAutocomplete } from '../../dialog/create_plex/form_components/SearchAutocomplete';

type Props = {
  ignoreTaskPermalinks: string[];
  onSelect: (option: Task) => void;
};

type Task = { id: string; body: SearchPostBody };

export function TaskSearch({ onSelect, ignoreTaskPermalinks }: Props): React.ReactElement {
  return (
    <SearchAutocomplete
      onSelect={onSelect}
      mapSearchResult={(searchOption) =>
        searchOption.body.__typename === 'SearchPostBody'
          ? {
              id: searchOption.id,
              body: searchOption.body,
            }
          : null
      }
      filterOptions={(options) => options.filter((option) => !ignoreTaskPermalinks.includes(option.body.permalink))}
      getPlexId={(option) => option.body.plexId}
      getTitle={(option) => option.body.title || ''}
      getBody={(option) => option.body.body || ''}
      filters={{ types: [SearchDocumentType.Milestone, SearchDocumentType.Task] }}
      autocompleteProps={{ size: 'small' }}
    />
  );
}
